// extracted by mini-css-extract-plugin
module.exports = {"header":"_layout_header__8cjgZ"};